// extracted by mini-css-extract-plugin
export default {"modernBtn":"courses-sort_modernBtn__sfFY2","coursesSortWrapper":"courses-sort_coursesSortWrapper__H4thr"};